export const ageMethod = "age nearest";
export const gateway = "https://gbiconsultants-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/gbiconsultants";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnYmljb25zdWx0YW50cyIsIm5hbWUiOiJnYmljb25zdWx0YW50cyIsImlhdCI6MTc3OTkyMTUyNywiZXhwIjoxOTM3NzA5NTI3fQ._8fpu4vpTeAeyL7JkGugeZefl_KDroRsRxIg3qJu16Y";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"gbiconsultants.link.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_gbiconsultants",
			brands: [
				"gbiconsultants.link.wawanesalife.com",
			],
			broker: "gbiconsultants",
			broker_formatted_name: "GBI Consultants",
			email: "Info@gbiconsultants.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.613.651.2224",
			privacyLink: "https://dbyrj622lou2k.cloudfront.net/PrivacyPolicy2026.pdf",
			website: "https://gbiconsultants.ca/",
			scope: "gbiconsultants#branding#gbiconsultants.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "gbiconsultants.link.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_gbiconsultants",
			brands: [
				"gbiconsultants.link.wawanesalife.com",
			],
			broker: "gbiconsultants",
			broker_formatted_name: "GBI Consultants",
			email: "Info@gbiconsultants.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.613.651.2224",
			privacyLink: "https://dbyrj622lou2k.cloudfront.net/PrivacyPolicy2026.pdf",
			website: "https://gbiconsultants.ca/",
			scope: "gbiconsultants#branding#gbiconsultants.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "gbiconsultants.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 17:38:47 GMT-0500 (Central Daylight Time)
